/**
 * Luna "Moonlight" theme — dedicated palette for the Luna assistant widget.
 * Night-sky header, moon-orb avatar, indigo accents. Keep every Luna surface
 * (bubble, header, messages, input, sidebar) on this palette for consistency.
 */
export const luna = {
  // Night sky (bubble + panel header)
  night: 'linear-gradient(135deg, #1C1B3A 0%, #2B2860 55%, #4338CA 130%)',
  nightHover: 'linear-gradient(135deg, #232254 0%, #343077 55%, #4F46E5 130%)',

  // Accents
  indigo: '#5856D6',
  indigoDeep: '#4338CA',

  // User message bubble + send button
  userBubble: 'linear-gradient(180deg, #5E5CE6 0%, #4B49C8 100%)',
  userBubbleHover: 'linear-gradient(180deg, #5654DB 0%, #4240BC 100%)',

  // Moon orb avatar (bubble icon backdrop, bot avatar, loading indicator)
  moonGlow: 'radial-gradient(circle at 30% 30%, #FFFFFF 0%, #E8E5FF 55%, #C7C2F5 100%)',

  // Soft lunar halo (header decoration)
  halo: 'rgba(199, 194, 245, 0.35)',
};

export default luna;
